module.exports = __webpack_public_path__ + "static/img/9-Sheffield-city-centre-regeneration.8fc7593a.jpg";